import gql from 'graphql-tag'

export const EXPORT_VOUCHERS = gql`
  query ExportVouchers($input: ExportInput) {
    export(input: $input) {
      signedLink
      receiptId
    }
  }
`
export const DELETE_VOUCHERS = gql`
  mutation DeleteVoucher($id: String) {
    deleteVoucher(id: $id)
  }
`

export const GET_VOUCHERS = gql`
  query getAllVouchers {
    vouchers {
      id
      reference_number
      description
      total_amount
      international_payment
      currency
      state
      paid_by_amin
      expense_period
      receivers_account_number
      created_at
      jamat
      pay_to
      department {
        id
        name
      }
      claimed_by {
        id
        first_name
        last_name
      }
      created_by {
        id
        first_name
        last_name
      }
      voucher_approvals {
        approved_at
        status
        comment
        order_number
        approver {
          id
          first_name
          last_name
          email
          majlis
          user_role {
            id
            name
            scope
          }
        }
        approval_stage {
          id
          is_payment_stage
        }
      }
      voucher_cost_category {
        cost_share
        cost_category {
          name
          code
          parent {
            name
          }
        }
        receipts {
          id
          path
        }
      }
      workflow {
        id
      }
    }
  }
`

export const GET_VOUCHERS_ALL = gql`
  query getAllVouchers($input: Paging) {
    vouchersAll(input: $input) {
      id
      reference_number
      description
      total_amount
      international_payment
      currency
      state
      paid_by_amin
      expense_period
      receivers_account_number
      jamat
      created_at
      department {
        id
        name
      }
      pay_to
      claimed_by {
        id
        first_name
        last_name
      }
      created_by {
        id
        first_name
        last_name
      }
      voucher_approvals {
        id
        approved_at
        status
        comment
        order_number
        approver {
          id
          first_name
          last_name
          email
          majlis
          user_role {
            id
            name
            scope
          }
        }
        approval_stage {
          id
          is_payment_stage
        }
      }
      voucher_cost_category {
        cost_share
        cost_category {
          name
          code
          parent {
            name
          }
        }
        receipts {
          id
          path
        }
      }
      workflow {
        id
        name
      }
    }
  }
`

export const GET_VOUCHER_BY_ID = gql`
  query Voucher($id: String) {
    voucher(id: $id) {
      id
      reference_number
      description
      jamat
      paid_by_amin
      payment_reference
      department {
        id
        name
      }
      total_amount
      state
      rejection_reason
      paid_by_amin
      receivers_account_number
      created_at
      financial_year
      international_payment
      currency
      pay_to
      claimed_by {
        id
        first_name
        last_name
      }
      created_by {
        id
        first_name
        last_name
        majlis
      }
      voucher_approvals {
        approved_at
        status
        comment
        order_number
        approver {
          id
          email
          majlis
          user_role {
            id
            name
            scope
          }
        }
        approval_stage {
          id
          is_payment_stage
        }
      }
      voucher_cost_category {
        id
        cost_share
        cost_category {
          id
          code
          name
          parent_id
        }
        receipts {
          id
          path
        }
      }
      workflow {
        id
      }
    }
  }
`
export const GET_UPLOAD_LINK = gql`
  mutation GetUploadLink($input: SignedLinkInput) {
    getUploadLink(input: $input) {
      signedLink
      receiptId
    }
  }
`

export const GET_DOWNLOAD_LINK = gql`
  query signedDownloadLink($id: String) {
    signedDownloadLink(id: $id) {
      signedLink
    }
  }
`

export const DELETE_RECEIPT = gql`
  mutation DeleteReceipt($id: String) {
    deleteReceipt(id: $id)
  }
`

export const GET_CATEGORIES = gql`
  query allCostCategories {
    costCategories {
      id
      parent_id
      name
      code
    }
  }
`

export const GET_DEPARTMENTS = gql`
  query {
    departments {
      id
      name
    }
  }
`
export const GET_USERS_LIST = gql`
  query getAllUsers {
    users {
      id
      first_name
      last_name
      majlis
      role
      site_admin
      user_role {
        id
        name
        scope
      }
    }
  }
`

/**
 * This is a utility function takes simple input object and map it into VoucherCreateInput
 * @param input Un mapped voucher input
 */
export const VoucherCreateInputMap = (
  input: VoucherInput
): VoucherCreateInput => {
  //@ts-ignore
  const mappedInput: VoucherCreateInput = { ...input }

  if (input.department) {
    mappedInput.department = {
      connect: {
        id: input.department,
      },
    }
  }

  if (input.created_by) {
    mappedInput.created_by = {
      connect: {
        id: input.created_by,
      },
    }
  }

  if (input.claimed_by) {
    mappedInput.claimed_by = {
      connect: {
        id: input.claimed_by,
      },
    }
  }
  mappedInput.voucher_cost_category = {
    create: input.voucher_cost_category.map((category) => {
      return {
        cost_category: {
          connect: {
            id: category.cost_category.id,
          },
        },
        cost_share: category.cost_share,
      }
    }),
  }
  if (input.workflow) {
    mappedInput.workflow = {
      connect: {
        id: input.workflow,
      },
    }
  }

  return mappedInput
}

export const CREATE_VOUCHER = gql`
  mutation Voucher($input: VoucherCreateInput) {
    createVoucher(input: $input) {
      id
      description
      total_amount
      paid_by_amin
      receivers_account_number

      pay_to

      claimed_by {
        id
        first_name
        last_name
      }

      created_by {
        first_name
        last_name
        id
      }
      voucher_cost_category {
        id
        cost_share
        cost_category {
          id
          name
          code
          parent_id
        }
      }
    }
  }
`

/**
 * This is a utility function takes simple input object and map it into VoucherUpdateInput
 * @param input Un mapped voucher input
 */
export const VoucherUpdateInputMap = (
  input: VoucherInputUpdate
): VoucherUpdateInput => {
  //@ts-ignore
  const mappedInput: VoucherUpdateInput = {
    id: input.id,
    description: input.description,
    state: input.state,
    financial_year: input.financial_year,
    international_payment: input.international_payment,
    currency: input.currency,
    pay_to: input.pay_to,
  }

  /**
   *  Now we need to retain the cost category ids for receipts so we not do that any more.
   *  cost categories need to created and updated via its own mutation, - Nosherwan
   */
  // mappedInput.voucher_cost_category = {
  //   create: input.voucher_cost_category.map((category) => {
  //     return {
  //       cost_category: {
  //         connect: {
  //           id: category.cost_category.id,
  //         },
  //       },
  //       cost_share: category.cost_share,
  //     }
  //   }),
  // }

  return mappedInput
}

export const UPDATE_VOUCHER = gql`
  mutation Voucher($input: VoucherUpdateInput) {
    updateVoucher(input: $input) {
      id
      description
      state
      international_payment
      currency
      department {
        id
        name
      }
      pay_to
      voucher_cost_category {
        id
        cost_share
        cost_category {
          id
          name
          code
          parent_id
        }
      }
    }
  }
`

export const CREATE_VOUCHER_COST_CATEGORY = gql`
  mutation CreateVoucherCostCategory($input: CreateVoucherCostCategoryInput) {
    createVoucherCostCategory(input: $input) {
      id
      cost_share
      cost_category {
        id
        parent_id
      }
    }
  }
`

export const UPDATE_VOUCHER_COST_CATEGORY = gql`
  mutation UpdateVoucherCostCategory($input: UpdateVoucherCostCategoryInput) {
    updateVoucherCostCategory(input: $input) {
      id
      cost_share
    }
  }
`

export const DELETE_VOUCHER_COST_CATEGORY = gql`
  mutation DeleteVoucherCostCategory($id: String) {
    deleteVoucherCostCategory(id: $id) {
      id
    }
  }
`

export type VoucherInput = {
  description: string
  department: string
  total_amount: number
  receivers_account_number: string
  created_by?: string
  claimed_by?: string
  pay_to?: string
  financial_year: number
  voucher_cost_category: inputCostCategory[]
  workflow?: number
}

export type VoucherCreateInput = {
  description: string
  // total_amount: number,
  financial_year: number
  department: Connect
  receivers_account_number: string
  created_by: Connect
  claimed_by: Connect
  pay_to: string
  voucher_cost_category: {
    create: voucherCostCategory[]
  }
  workflow?: {
    connect: {
      id: number
    }
  }
}

export type VoucherInputUpdate = {
  id: string
  description: string
  state: string
  financial_year: number
  international_payment: boolean
  currency: string
  pay_to: string
  voucher_cost_category: inputCostCategoryUpdate[]
}

export type VoucherUpdateInput = {
  id: string
  description: string
  department: Connect
  pay_to: string
  state: string
  financial_year: number
  international_payment: boolean
  currency: string
  voucher_cost_category: {
    create: voucherCostCategory[]
  }
}

export type CreateVoucherCostCategoryInput = {
  voucher_id: string
  cost_category_id: string
  cost_share: number
}

export type UpdateVoucherCostCategoryInput = {
  id: string
  cost_category_id: string
  cost_share: number
}

type voucherCostCategory = {
  cost_category: Connect
  cost_share: number
}
type Connect = {
  connect: {
    id: string
  }
}
type inputCostCategory = {
  cost_category: { id: string }
  cost_share: number
}
type inputCostCategoryUpdate = {
  cost_category: { id: string }
  cost_share: number
}
